"use client";

import { useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import Image from "next/image";
// import { signIn } from "next-auth/react";

import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Typography } from "@/components/custom/typography";
import { InputForm } from "@/components/custom/forms/input-items";
import {
  Form,
  FormField,
  FormItem,
  FormLabel,
  FormControl,
} from "@/components/ui/form";
import { CustomDialog } from "@/components/custom/dialog";

const formSchema = z.object({
  emailcms: z.string().email("유효한 이메일을 입력해주세요."),
  passwordcms: z.string().min(1, "비밀번호를 입력해주세요."),
  remembercms: z.boolean().optional(),
});

type DoohCMSLoginFormType = z.infer<typeof formSchema>;

interface DoohCMSLoginDialogProps {
  open: boolean;
  onClose: () => void;
  onSuccess?: () => void;
}

export default function DoohCMSLoginDialog({
  open,
  onClose,
}: // onSuccess,
DoohCMSLoginDialogProps) {
  const form = useForm<DoohCMSLoginFormType>({
    resolver: zodResolver(formSchema),
    mode: "onChange",
    defaultValues: {
      emailcms: "",
      passwordcms: "",
      remembercms: false,
    },
  });

  const onSubmit = async (data: DoohCMSLoginFormType) => {
    console.warn(data);
    // try {
    //   const res = await signIn("credentials", {
    //     redirect: false,
    //     email: data.emailcms,
    //     password: data.passwordcms,
    //     isCMSUser: true,
    //   });
    //   if (res?.ok) {
    //     onSuccess?.();
    //   }
    // } catch (error) {
    //   console.error("Connection error:", error);
    // }
  };

  return (
    <CustomDialog
      open={open}
      onOpenChange={onClose}
      title={
        <div className="text-center">
          <Image
            src="/images/cms.svg"
            alt="logo"
            width={120}
            height={120}
            className="mx-auto"
          />
          <Typography
            variant="body4"
            tone="description"
            className="text-center my-6"
          >
            D’ooh CMS 계정으로 ADeX에 가입하실 수 있습니다.
          </Typography>
        </div>
      }
      size="sm"
      className="p-10 gap-0"
      stopInteractOutside
      buttons={null}
      okText=""
      cancelText=""
    >
      <Form {...form}>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            e.stopPropagation();
            form.handleSubmit(onSubmit)();
          }}
          className="px-20 py-11 flex flex-col gap-5"
        >
          <div className="group">
            <Typography
              variant={"body3"}
              className="text-gray-scale-700 font-semibold mb-1"
            >
              아이디(이메일)
            </Typography>
            <InputForm
              control={form.control}
              name="emailcms"
              type="text"
              placeholder="abcde@abc.com"
              className="border-gray-scale-300  group-focus-within:border-gray-900"
              keyT={"validation"}
            />
          </div>

          <div className="group">
            <Typography
              variant={"body3"}
              className="text-gray-scale-700 font-semibold mb-1"
            >
              비밀번호
            </Typography>
            <InputForm
              control={form.control}
              name="passwordcms"
              type="password"
              placeholder="**********"
              className="border-gray-scale-300  group-focus-within:border-gray-900"
              keyT={"validation"}
            />
          </div>
          <FormField
            control={form.control}
            name="remembercms"
            render={({ field }) => (
              <FormItem className="flex items-center">
                <FormControl>
                  <Checkbox
                    checked={field.value}
                    onCheckedChange={field.onChange}
                  />
                </FormControl>
                <FormLabel className=" text-gray-scale-700 text-sm mb-0">
                  아이디 저장
                </FormLabel>
              </FormItem>
            )}
          />

          <Button
            type="submit"
            variant="secondary"
            className="w-full bg-[#58C65D] text-white font-semibold text-base "
          >
            로그인
          </Button>

          <div
            className="text-center text-sm text-[#C0C0C0] font-normal underline underline-offset-2 cursor-pointer mt-5"
            onClick={onClose}
          >
            로그인 취소
          </div>
        </form>
      </Form>
    </CustomDialog>
  );
}
